"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.services = void 0;
var services = {
  transactions: "transactions",
  offers: "offers",
  treasury: "treasury",
  tools: "tools",
  payouts: "payouts",
  commonOnboarding: "common-onboarding",
  chargeback: "chargeback",
  neobanking: "neobanking",
  neomarketplace: "neomarketplace",
  accountpayables: "accountpayables",
  alternateOnboarding: "alternateOnboarding",
  neolending: "neolending"
};
exports.services = services;